import { PATH } from '../constants';

import decodeHtmlEntities from './decodeHtmlEntities';

interface TagBalance {
  openTags: string[];
  closeTags: string[];
  unclosedCount: number;
}

const analyzeTagBalance = (
  text: string,
  openPattern: RegExp,
  closePattern: RegExp
): TagBalance => {
  const openTags = text.match(openPattern) || [];
  const closeTags = text.match(closePattern) || [];
  const unclosedCount = openTags.length - closeTags.length;

  return { openTags, closeTags, unclosedCount };
};

const processUnclosedTags = (
  html: string,
  targetTagNames: string[] = ['i', 's', 'u', 'code', 'strong', 'a', 'span']
): string => {
  let processedHtml = decodeHtmlEntities(html);

  targetTagNames.forEach((tagName) => {
    const openTagPattern = new RegExp(`<${tagName}(?:\\s+[^>]*)?(?:>|$)`, 'g');
    const closeTagPattern = new RegExp(`<\\/${tagName}>`, 'g');

    // 첫 번째 닫는 태그 위치 찾기
    const firstCloseTagMatch = processedHtml.match(closeTagPattern);
    const firstCloseTagIndex = firstCloseTagMatch
      ? processedHtml.indexOf(firstCloseTagMatch[0])
      : -1;

    // 마지막 여는 태그 위치 찾기
    const allOpenTags = [...processedHtml.matchAll(openTagPattern)];
    const lastOpenTagIndex = allOpenTags.length
      ? allOpenTags[allOpenTags.length - 1].index
      : -1;

    // 첫 닫는 태그 이전 영역 분석
    if (firstCloseTagIndex !== -1) {
      const beforeFirstClose = processedHtml.substring(0, firstCloseTagIndex);
      const beforeBalance = analyzeTagBalance(
        beforeFirstClose,
        openTagPattern,
        closeTagPattern
      );
      const lastOpenTag =
        beforeBalance.openTags[beforeBalance.openTags.length - 1];
      const attributesMatch = lastOpenTag?.match(
        new RegExp(`<${tagName}\\s+(.*?)>`)
      );
      const attributes = attributesMatch
        ? attributesMatch[1]
        : tagName === 'a'
          ? `href="${PATH.HOME}"`
          : '';

      if (beforeBalance.openTags.length === 0) {
        // 여는 태그가 없는 경우 추가
        const tag =
          attributes.length > 0 ? `<${tagName} ${attributes}>` : `<${tagName}>`;

        processedHtml = tag + processedHtml;
      }
    }

    // 마지막 여는 태그 이후 영역 분석
    if (lastOpenTagIndex !== -1) {
      const afterLastOpen = processedHtml.substring(lastOpenTagIndex);
      const afterBalance = analyzeTagBalance(
        afterLastOpen,
        openTagPattern,
        closeTagPattern
      );

      if (afterBalance.closeTags.length === 0) {
        // 닫는 태그가 없는 경우 추가
        processedHtml = processedHtml + `</${tagName}>`;
      }
    }
  });

  return processedHtml;
};

export default processUnclosedTags;
